import axiosInstance from "@/config/axiosInstance";

const VET_DEMO_ENDPOINT = "https://endsofttech.com/api/vet-demo";
/**
 * Send contact form email
 * @param {Object} formData - Contact form data
 * @param {string} formData.name - Contact name
 * @param {string} formData.email - Contact email
 * @param {string} formData.contact - Contact phone number
 * @param {string} formData.company - Company name
 * @param {string} formData.message - Message content
 * @returns {Promise<Object>}
 */
export const sendContactEmail = async (formData) => {
  const response = await axiosInstance.post("/api/contact", formData);
  return response.data;
};

/**
 * Send quote request email
 * @param {Object} formData - Quote request data
 * @param {string} formData.name - Contact name
 * @param {string} formData.email - Contact email
 * @param {string} formData.contact - Contact phone number
 * @param {string} formData.company - Company name
 * @param {string} formData.projectDetails - Project details
 * @returns {Promise<Object>}
 */
export const sendQuoteRequest = async (formData) => {
  const response = await axiosInstance.post("/api/quote", formData);
  return response.data;
};

/**
 * Send demo request
 * @param {Object} formData - Demo request form data (camelCase from the form)
 * @returns {Promise<Object>}
 */
export const sendDemoRequest = async (formData) => {
  const payload = {
    first_name: formData.firstName,
    last_name: formData.lastName,
    clinic_name: formData.clinicName,
    clinic_address: formData.clinicAddress,
    contact_number: formData.contactNumber,
    email_address: formData.email,
    has_software: formData.hasSoftware,
    current_software_name: formData.currentSoftwareName || "",
    business_type: formData.businessType || "",
    preferred_date: formData.preferredDate || "",
    preferred_time: formData.preferredTime || "",
    turnstileToken: formData.turnstileToken || "",
  };
  const response = await axiosInstance.post(VET_DEMO_ENDPOINT, payload);
  return response.data;
};

/**
 * Send job application
 * @param {FormData} formData - Job application data (includes file upload)
 * @returns {Promise<Object>}
 */
export const sendJobApplication = async (formData) => {
  const response = await axiosInstance.post("/api/job-application", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

/**
 * Subscribe to newsletter
 * @param {string} email - Subscriber email
 * @param {string} source - Where the subscription came from
 * @returns {Promise<Object>}
 */
export const subscribeNewsletter = async (
  email,
  source = "Website newsletter",
  turnstileToken = ""
) => {
  const response = await axiosInstance.post("/api/newsletter/subscribe", {
    email,
    source,
    turnstileToken,
  });
  return response.data;
};
